import React from 'react';
import bgImg from 'images/b1.png';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import './Hero.css'

import {Carousel} from 'react-responsive-carousel';

import firstImg from 'images/new-mobile-3.png';
// import insurance from 'images/Insurance InFocus.png';
// import realEstate from 'images/Real Estate InFocus.png';
// import buildingAndConstruction from 'images/Construction InFocus.png';
// import utilities from 'images/Utilities InFocus.png';
// import health from 'images/Health InFocus.png'; 
// import education from 'images/Training and education InFocus.png';
import CarouselItem from 'components/CarouselItem';

type HeroProps = {
  id: string
}
const Hero: React.FC<HeroProps> = ({ id }) => {

  const imgList = [
    {img: firstImg, title: 'Connected Solutions'},
    // {img: insurance, title: 'Insurance'},
    // {img: realEstate, title: 'Real Estate'},
    // {img: buildingAndConstruction, title: 'Building and Construction'},
    // {img: utilities, title: 'Utilities'},
    // {img: health, title: 'Health'},
    // {img: education, title: 'Training and Education'},
  ]

  return (
    <div id={id} className='pt-40' style={{ position: 'relative', height: '48rem', width: '100%'}}>
      <div className='' style={{ 
        position: 'absolute', zIndex: 20, top: 0, right: 0, bottom: 0, left: 0,
        background: 'linear-gradient(to right, rgba(255, 255, 255, 0.3)20%, rgba(9, 179, 239, 0.4) 70%)',
        height: '48rem',
      }} />
      <img className='formatBg hidden lg:flex xl:flex' alt='' src={bgImg} style={{ height: '48rem',position : 'absolute', zIndex: 10, top: 0, right: 0, bottom: 0, left: 0}} />
      
      <Carousel showStatus={false} showThumbs={false} showIndicators={false}
        className='relative z-30 sm:pt-10 md:pt-10 lg:pt-10 xl:pt-10 h-full'
      >
        {imgList.map((item, index)=> {
          return (
            <CarouselItem key={index} img={item.img} title={item.title} />
          )
        })}
      </Carousel>

    </div>
    
  )
}
export default Hero;